// extracted by mini-css-extract-plugin
module.exports = {"Component":"CustomerTable_Component__1npwb"};